module.exports = __webpack_public_path__ + "static/media/loanx-Pattern.5659763f.svg";